import React, {useState} from 'react';
import {Typography, withStyles} from '@material-ui/core';
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import Toolbar from '../../components/Toolbar/Toolbar';
import {withPaginator} from '../../components/Pagination';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TableBody from "@material-ui/core/TableBody";
import TableRowClickable from "../../components/Form/TableRowClickable";
import TableCell from "@material-ui/core/TableCell";
import TableCellSortable, {xOrder} from "../../components/Form/TableCellSortable";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import EllipsisWithTooltip from "../../components/Formater/EllipsisWithTooltip";
import DialogSelector from "../../components/Personnel/Dialogs/DialogSelector";

const PersonnelIndex = ({classes, items: personnel, search, buildings}) => {

    const {column, order, filter } = search;

    let searchQuery = `/personnel?`;

    if (column) {
        searchQuery += '&column=' + column;
    }
    if (order) {
        searchQuery += '&order=' + order;
    }

    const [open, setOpen] = useState(false);
    const [type, setType] = useState('')
    const handleOpen = (type) => {
        setOpen(true);
        setType(type);
    };
    const handleClose = (type) => {
        setOpen(false);
    };

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('personnel.accounting')}
                subtitle={''}
                items={[
                    {
                        icon: 'add',
                        text: i18n.get('personnel.add'),
                        href: `/personnel/create`,
                        size: 'small',
                    },
                    {
                        icon: 'table_view',
                        text: i18n.get('personnel.export'),
                        type: 'button',
                        size: 'small',
                        onClick: () => handleOpen('export'),
                    },
                    {
                        icon: 'swap_horiz',
                        text: i18n.get('personnel.swap'),
                        type: 'button',
                        size: 'small',
                        onClick: () => handleOpen('swap'),
                    }
                ]}
            />
            {/*<SearchForm url={searchQuery} {...search} />*/}
            <Paper className={classes.paper}>
                {personnel && personnel.length > 0 && (
                    <Table className={classes.list}>
                        <TableHead>
                            <TableRow>
                                <TableCellSortable
                                    style={{ width:120 }}
                                    action={`?column=number&order=${xOrder(order)}`}
                                    active={column === 'number'}
                                    order={order}
                                >
                                    {i18n.get('personnel.form.number')}
                                </TableCellSortable>
                                <TableCellSortable
                                    action={`?column=last_name&order=${xOrder(order)}`}
                                    active={column === 'name'}
                                    order={order}
                                >
                                    {i18n.get('personnel.name')}
                                </TableCellSortable>
                                <TableCell scope={'col'} align={'center'}>
                                    {i18n.get('personnel.form.profession')}
                                </TableCell>
                                {/*<TableCellSortable>*/}
                                {/*    {i18n.get('personnel.form.type_of_remuneration')}*/}
                                {/*</TableCellSortable>*/}
                                <TableCell  scope={'col'} align={'center'}>
                                    {i18n.get('personnel.form.linked_user')}
                                </TableCell>
                                {window.can('personnel.create') && (
                                    <TableCell scope="col" align={'center'}>
                                        {i18n.get('personnel.actions.self')}
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {personnel.map( (worker, idx) =>
                                <TableRowClickable key={`worker_`+idx}>
                                    <TableCell>
                                        <Typography component="h6">
                                            <EllipsisWithTooltip>
                                                {worker.number}
                                            </EllipsisWithTooltip>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography component="h6">
                                            <EllipsisWithTooltip>
                                                {worker.last_name + ', ' + worker.first_name}
                                            </EllipsisWithTooltip>
                                        </Typography>
                                    </TableCell>
                                    <TableCell align={'center'}>
                                        <Typography component="h6">
                                            <EllipsisWithTooltip>
                                                {worker.profession && worker.profession.name}
                                            </EllipsisWithTooltip>
                                        </Typography>
                                    </TableCell>
                                    {/*<TableCell>*/}
                                    {/*    <Typography component="h6">*/}
                                    {/*        <EllipsisWithTooltip>*/}
                                    {/*            {i18n.get('personnel.form.remuneration_' + worker.type_of_remuneration )}*/}
                                    {/*        </EllipsisWithTooltip>*/}
                                    {/*    </Typography>*/}
                                    {/*</TableCell>*/}
                                    <TableCell align={'center'}>
                                        <Typography component="h6">
                                            <EllipsisWithTooltip>
                                                {worker.user && worker.user.name}
                                            </EllipsisWithTooltip>
                                        </Typography>
                                    </TableCell>
                                    {window.can('personnel.create') && (
                                        <TableCell style={{cursor:'default'}}  align={'center'}
                                            onClick={e => { e.stopPropagation('all'); }}>
                                            <IconButton
                                                component="a"
                                                href={`/personnel/${worker.id}`}
                                            >
                                                <Icon>find_in_page</Icon>
                                            </IconButton>

                                            <IconButton
                                                component="a"
                                                href={`/personnel/${worker.id}/edit`}
                                            >
                                                <Icon>edit</Icon>
                                            </IconButton>
                                        </TableCell>
                                    )}
                                </TableRowClickable>
                            )}
                        </TableBody>
                        {/*<Pagination colSpan={5} classes={{spacer: "none"}}/>*/}
                    </Table>
                )}
            </Paper>

            <DialogSelector
                type={type}
                open={open}
                handleClose={handleClose}
                data={{
                    buildings: [...buildings],
                    personnel: [...personnel],
                }}
            />
        </Layout>
    );
}

const styles = theme => ({
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    list: {
        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        }
    },
});


export default withStyles(styles)(
    withPaginator('personnel')(PersonnelIndex)
);
